import { Checkbox, CheckboxOptionProps } from '@innovationnorway/component-library';
import React from 'react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { CountyWithMunicipalities, Municipalities } from 'src/features/one-way-in/hooks/use-geonorge';
import { TargetData } from '../hooks/subforms/use-target-form';

type Props = {
  row: { original: CountyWithMunicipalities };
  getValues: UseFormGetValues<TargetData>;
  setValue: UseFormSetValue<TargetData>;
};

const CountyMunicipalities: React.FC<Props> = ({ row, getValues, setValue }) => {
  const municipalities = getValues('municipalities');

  const municipalityOptions: CheckboxOptionProps[] = React.useMemo(() => {
    return row.original.kommuner
      .sort((a, b) => a.kommunenavnNorsk.localeCompare(b.kommunenavnNorsk, 'nb-NO'))
      .map((municipality: Municipalities) => ({
        value: municipality.kommunenummer,
        text: municipality.kommunenavnNorsk,
        selected: municipalities.includes(municipality.kommunenummer),
      }));
  }, [row.original.kommuner, municipalities]);

  const handleOnChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { checked, value } = e.currentTarget;

    const currentMunicipalities = getValues('municipalities') || [];

    if (checked) {
      if (!currentMunicipalities.includes(value)) {
        setValue('municipalities', [...currentMunicipalities, value]);
      }
    } else {
      setValue(
        'municipalities',
        currentMunicipalities.filter((municipalityId) => municipalityId !== value),
      );
    }
  };

  return (
    <div className="margin-left--5">
      <Checkbox name="municipalities" options={municipalityOptions} onChange={handleOnChange} />
    </div>
  );
};

export default CountyMunicipalities;
